import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";
import { RoleType } from "../components/main/body/screens/IAM/Roles/types/RoleType"

export class RoleStore {

    historySearchString = [];
    role=[];

    rootStore: IRootStore;
    roles: RoleType[] = [];
   
    selectedRoles: (string | number)[] = [];
    showDeleteConfirmation: boolean = false;
    rolesActionMenu:boolean = false;
    updates : number = 0;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    handleRolelist(list : any){
        this.historySearchString = list;
    }

    get getRolelist(){
       return this.historySearchString;
    }
    setRolesActionMenu =() =>{
        this.rolesActionMenu = !this.rolesActionMenu;
    }
    resetRolesActionMenu =() =>{
        this.rolesActionMenu = false;
    }
    get getRolesActionMenu(){
        return this.rolesActionMenu;
    }
    handleSelectedRoles = (selectedRoles: (string | number)[]) => {
        this.selectedRoles = selectedRoles;
    }
    get getSelectedRoles() {
        return this.selectedRoles;
    }
    handleDeleteConformation = (isDeleteConfirm: boolean) => {
        this.showDeleteConfirmation = isDeleteConfirm;
    }
    get getDeleteConformation() {
        return this.showDeleteConfirmation;
    }
    handleRoles = (roles: RoleType[]) => {
        this.roles = roles;
    }
    get getRoles() {
        return this.roles;
    }
    handleupdates = () => {
        this.updates++;
    }
    get getupdates () {
        return this.updates ;
    }



}
